import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import './style.scss';

import ProfileStore from 'stores/EmployeeProfile/ProfileStore';

interface Props {
  profile?: ProfileStore;
}

@inject('profile')
@observer
class ProfileContacts extends Component<Props> {
  render() {
    return (
      <section className={'profileContacts__contacts'}>
        {/* {getRole(Roles.hostess) && (
          <div className={'profileContacts__tags_wrapper'}>
            <Tags profile={profile!} />
          </div>
        )} */}

        <h3 className={'profileContacts__title'}>
          <FormattedMessage id="profile.information.title" />
        </h3>

        <div className={'profileContacts__info'}>
          {this.userContacts.map(it => (
            <Fragment key={it.label}>
              <div className={'profileContacts__info_label'}>
                <FormattedMessage id={it.label} />
              </div>

              <div className={'profileContacts__info_value'}>{it.value}</div>
            </Fragment>
          ))}
        </div>
      </section>
    );
  }

  get userContacts() {
    const { profile } = this.props;

    const userContacts = [
      {
        value: profile!.id,
        label: 'NUTZERNUMMER',
      },
      {
        value: profile!.nickname,
        label: 'NICKNAME',
      },
    ];

    if (profile?.publicEmail) {
      userContacts.push({
        value: profile!.email,
        label: 'EMAIL',
      });
    }

    return userContacts;
  }
}

export default ProfileContacts;
